import { useSignUp } from "@clerk/clerk-react";
import TextInput from "Components/TextInput/TextInput";
import { Button } from "Components/ui/button";
import { Separator } from "Components/ui/separator";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apple from "../../Assets/Images/apple.png";
import facebook from "../../Assets/Images/facebook.png";
import google from "../../Assets/Images/google.png";
import AuthCard from "../../Components/AuthCard/AuthCard";
import AuthLayout from "../../Components/AuthLayout/AuthLayout";
import { toast } from "sonner";

function SignUp() {
  const navigate = useNavigate();

  const { id } = useParams();

  const [data, setData] = useState({});

  const { isLoaded, signUp } = useSignUp();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoaded)
      try {
        setLoading(true);
        const signedUp = await signUp.create({
          firstName: data?.f_name,
          lastName: data?.l_name,
          emailAddress: data.email,
          strategy: "password",
            ...(id && {
          unsafeMetadata: {
            partnerId: id,
          },
        }),

          password: data.password,
        });

        if (
          signedUp?.status == "missing_requirements" &&
          signedUp?.unverifiedFields?.includes("email_address")
        ) {
          await signUp.prepareEmailAddressVerification({
            strategy: "email_code",
          });
          navigate("/auth/OtpVerification?email=" + signedUp.emailAddress);
        } else {
          window.location.href = "/";
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        setError(e);
      }
  };

  useEffect(() => {
    if (error) {
      toast.error(error.message, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
    }
  }, [error]);

  return (
    <form className="flex flex-col gap-6" onSubmit={(e) => handleSubmit(e)}>
      <div className="flex justify-between gap-4">
        <TextInput
          label="First Name"
          placeholder="Enter your first name"
          type="text"
          required
          value={data?.f_name}
          onChange={(e) => setData({ ...data, f_name: e.target.value })}
        />
        <TextInput
          label="Last Name"
          placeholder="Enter your last name"
          type="text"
          required
          value={data?.l_name}
          onChange={(e) => setData({ ...data, l_name: e.target.value })}
        />
      </div>
      <TextInput
        label="Email"
        placeholder="Enter your email"
        type="email"
        required
        value={data?.email}
        onChange={(e) => setData({ ...data, email: e.target.value })}
      />
      <TextInput
        label="Password"
        placeholder="Enter your password"
        type="password"
        required
        value={data?.password}
        onChange={(e) => setData({ ...data, password: e.target.value })}
      />

      <Button
        type="submit"
        className="p-[1.3rem]"
        disabled={!isLoaded || loading}
      >
        {loading ? "Signing Up" : "Create Account"}
      </Button>


    </form>
  );
}

export default SignUp;
